module.exports = __webpack_public_path__ + "img/seejc_logo.7a193dec.png";